import '../../style/base.css';
import '../index.css';


//////////////////
// WEBPACK FOOTER
// ./~/vant/es/loading/style/index.js
// module id = 174
// module chunks = 31